export const TIMEOUT_FORM_SAVING_MIN = 1000;
